import { render, staticRenderFns } from "./editAPhysicalCategory.vue?vue&type=template&id=8e9072de&scoped=true&"
import script from "./editAPhysicalCategory.vue?vue&type=script&lang=js&"
export * from "./editAPhysicalCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9072de",
  null
  
)

export default component.exports